import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.InstitutionTypeEnumSortEnum>
) {
  const { pagination, sort, filter } = params;

  const {
    institutionTypeEnumList: { items: data, total },
  } = await sdk.getListInstitutionTypeEnum(
    filterSortPage({
      sort,
      pagination,
      filter,
    })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { institutionTypeEnum: data } = await sdk.getOneInstitutionTypeEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { institutionTypeEnumMany: data } =
    await sdk.getManyInstitutionTypeEnum({
      ids,
    });

  return {
    data,
  };
}

/*********************************************************************/
export const institutionTypeEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
